export default {
  desktop_access:
    'Yêu cầu truy cập di động<br/><br/>Để có trải nghiệm Ví Bitcash liền mạch, vui lòng chuyển sang thiết bị di động của bạn. Chúng tôi khuyên bạn nên sử dụng phiên bản mới nhất của trình duyệt dành cho thiết bị di động của mình.<br/><br/> Các trình duyệt được hỗ trợ bao gồm',
  desktop_access_2:
    'Để có khả năng tương thích và bảo mật hoàn toàn, hãy cập nhật trình duyệt và thiết bị di động của bạn.',
}
